import { gql } from "@apollo/client"
import { EVENT_FRAGMENT } from "@graphql"

const UPDATE_EVENT = gql`
  ${EVENT_FRAGMENT}

  mutation($input: UpdateEventInput!) {
    updateEvent(input: $input) {
      ...EventFragment
    }
  }
`

export { UPDATE_EVENT }
